import { Skeleton } from '../../../Skeleton'
import {
  REQUEST_PROFILE_OPEN_ACTIVITIES_SKELETON_ROW_TITLE_WIDTHS,
  REQUEST_PROFILE_OPEN_ACTIVITIES_SKELETON_ROWS_COUNT,
} from '../RequestProfileOpenActivities.constants'

import * as styles from './RequestProfileOpenActivitiesSkeleton.module.css'

function RequestProfileOpenActivitiesSkeleton() {
  return (
    <div className={styles.RequestProfileOpenActivitiesSkeleton}>
      <div className={styles.headerRow}>
        <Skeleton className={styles.headerTitleSkeleton} />
      </div>
      {Array.from({
        length: REQUEST_PROFILE_OPEN_ACTIVITIES_SKELETON_ROWS_COUNT,
      }).map((_, index) => (
        <div className={styles.row} key={index}>
          <Skeleton className={styles.rowStatusSkeleton} />
          <Skeleton
            className={styles.rowTitleSkeleton}
            style={{
              width:
                REQUEST_PROFILE_OPEN_ACTIVITIES_SKELETON_ROW_TITLE_WIDTHS[
                  index
                ],
            }}
          />
        </div>
      ))}
      <div className={styles.footer}>
        <Skeleton className={styles.footerSkeleton} />
      </div>
    </div>
  )
}

export default RequestProfileOpenActivitiesSkeleton
